import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { Link } from "./library/link";
import { ResponsivePicture } from "../../../Shared/components/Image";
export const Book = (p)=>{
    let content = (p)=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "book__caption",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "book__header title--xs",
                            children: "Boekentip"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "book__title title--s",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: p.title
                            })
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "book__text text--s",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: p.author
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "book__visual",
                    children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                        className: "book__image",
                        defaultImageUrl: p.imageUrlFallback,
                        cropsPerMedia: [
                            {
                                crops: [
                                    {
                                        url: p.imageUrl,
                                        width: 195
                                    },
                                    {
                                        url: p.imageUrlLarge,
                                        width: 400
                                    }
                                ]
                            }
                        ],
                        height: 195,
                        alt: p.imageAlt
                    })
                })
            ]
        });
    return /*#__PURE__*/ _jsx("article", {
        className: `book ${p.className || ''}`,
        children: p.url && p.url != "" ? /*#__PURE__*/ _jsx(Link, {
            url: p.url,
            className: "book__inner book__link",
            children: content(p)
        }) : /*#__PURE__*/ _jsx("div", {
            className: "book__inner",
            children: content(p)
        })
    });
};
export const BooksBlock = (p)=>/*#__PURE__*/ _jsxs("aside", {
        className: "books container--lg align--center",
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: "books__header container--m align--center",
                children: [
                    p.title && /*#__PURE__*/ _jsx("h2", {
                        className: "books__title container--xs title--m",
                        children: p.title
                    }),
                    p.text && /*#__PURE__*/ _jsx("p", {
                        className: "books__intro container--xs",
                        children: p.text
                    })
                ]
            }),
            !p.books.isEmpty() && /*#__PURE__*/ _jsx("div", {
                className: "books__list",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "container--mg align--center",
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "books__list-inner",
                        children: p.books.map((book)=>/*#__PURE__*/ _jsx("li", {
                                className: "books__item",
                                children: /*#__PURE__*/ _jsx(Book, {
                                    ...book
                                })
                            }, `book-${book.title}-${book.author}`))
                    })
                })
            })
        ]
    });
{}